module.exports = __webpack_public_path__ + "img/N220-2.9993fbdb.png";